import script from "./EditHealthGoals.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditHealthGoals.vue?vue&type=script&setup=true&lang=ts"

import "./EditHealthGoals.vue?vue&type=style&index=0&id=27d585f5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d585f5"]])

export default __exports__